import { render, staticRenderFns } from "./BasicDataConfiguration.vue?vue&type=template&id=156c5d17&scoped=true&"
import script from "./BasicDataConfiguration.vue?vue&type=script&lang=js&"
export * from "./BasicDataConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataConfiguration.vue?vue&type=style&index=0&id=156c5d17&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c5d17",
  null
  
)

export default component.exports